export const hasCookie = (name: string): boolean => {
  return document.cookie.split('; ').some((cookie) => cookie.startsWith(`${name}=`));
};
